import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ButtonDeleteComponent } from '@app/shared/ui/buttons/button-delete/button-delete.component';
import { ButtonSecondaryComponent } from '@app/shared/ui/buttons/button-secondary/button-secondary.component';
import { DriverSettingsService } from '@features/dashboard/settings/driver-settings.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'crm-driver-settings-ekv-dialog',
  imports: [
    MatDialogContent,
    TranslatePipe,
    ButtonDeleteComponent,
    MatDialogActions,
    MatDialogTitle,
    MatDialogClose,
    MatIcon,
    ButtonSecondaryComponent,
  ],
  templateUrl: './driver-settings-ekv-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './driver-settings-ekv-dialog.component.scss',
})
export class DriverSettingsEkvDialog {
  protected readonly settingsService: DriverSettingsService = inject(DriverSettingsService);

  protected readonly data = inject<{ key: string }>(MAT_DIALOG_DATA);
  protected readonly dialogRef = inject(MatDialogRef<DriverSettingsEkvDialog>);

  closeDialog() {
    this.dialogRef.close('someValue');
  }

  forceDelete() {
    this.settingsService.removeEdiKeys([this.data.key], true).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
    });
  }
}
